module.exports = __webpack_public_path__ + "static/assets/0cc8cff23987f4d8d8813ec795205b6c.png";